import { memo, useCallback, useState } from "react";

import {
  ToggleView,
  type ToggleCommonProps,
} from "@react/components/Toggle/Toggle.view";

interface Props extends ToggleCommonProps {
  initialValue?: boolean;
}

const ToggleBase = ({ alt, disabled, initialValue, onChange, type }: Props) => {
  const [value, setValue] = useState<boolean>(initialValue ?? false);

  const handleOnChange = useCallback(
    (value: boolean) => {
      setValue(value);

      if (onChange) {
        onChange(value);
      }
    },
    [onChange]
  );

  const toggleViewProps = {
    value,
    alt,
    disabled,
    type,
    onChange: handleOnChange,
  };

  return <ToggleView {...toggleViewProps} />;
};

export const Toggle = memo(ToggleBase);
